// extracted by mini-css-extract-plugin
export var backContainer = "listGdd-module--back-container--f40aa";
export var backLink = "listGdd-module--back-link--65c05";
export var backToSite = "listGdd-module--back-to-site--02917";
export var imgLogo = "listGdd-module--img-logo--b3417";
export var listGdd = "listGdd-module--list-gdd--cd813";
export var titleGdd = "listGdd-module--title-gdd--ecd2e";